// يضغط صور الجوال الكبيرة قبل الرفع (أبعاد قصوى + JPEG) لتفادي حدّ 5MB على الخادم.
const MAX_DIM = 1600;
const TYPE = "image/jpeg";

export const compressImage = async (file, quality = 0.82) => {
  if (!file.type?.startsWith("image/")) return file; // PDF أو غير صورة — يُرفع كما هو
  let bitmap;
  try {
    bitmap = await createImageBitmap(file);
  } catch {
    return file; // المتصفح لا يفكّ ترميز الصورة — نرفع الأصل
  }
  const scale = Math.min(1, MAX_DIM / Math.max(bitmap.width, bitmap.height));
  const w = Math.round(bitmap.width * scale);
  const h = Math.round(bitmap.height * scale);
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  canvas.getContext("2d").drawImage(bitmap, 0, 0, w, h);
  bitmap.close?.();
  const blob = await new Promise((res) => canvas.toBlob(res, TYPE, quality));
  if (!blob) return file;
  const name = (file.name || "photo").replace(/\.[^.]+$/, "") + ".jpg";
  return new File([blob], name, { type: TYPE });
};
